"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { FiInfo } from "react-icons/fi";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { Controls } from "@/app/[tenant]/(console)/scribe/playground/[id]/attachment-item";
import { Button } from "@/components/ui";
import { Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ChatMarkdown } from "./chat-markdown";
interface AIChatSummaryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  summary: string;
  /** Composed content — when provided, renders this instead of default markdown */
  children?: React.ReactNode;
}
export function AIChatSummaryDialog(t0) {
  const $ = _c(20);
  const {
    open,
    onOpenChange,
    summary,
    children
  } = t0;
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  let t1;
  if ($[0] !== summary) {
    t1 = typeof summary === "string" ? summary : typeof summary === "object" && summary !== null ? JSON.stringify(summary) : String(summary || "");
    $[0] = summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const summaryString = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      const target = e.target as HTMLElement;
      if (target.tagName === "IMG") {
        const imgSrc = (target as HTMLImageElement).src;
        if (imgSrc) {
          setPreviewImageUrl(imgSrc);
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleImageClick = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10"><FiInfo className="h-5 w-5 text-primary" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogTitle className="text-h2 text-foreground">Conversation Summary</DialogTitle>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogHeader className="border-b border-border pb-5"><div className="flex items-start gap-3">{t3}<div className="flex-1 space-y-3">{t4}<div className="space-y-2"><p className="text-body leading-relaxed text-foreground-secondary">Long conversations are automatically summarized to help the AI maintain context while keeping responses fast and relevant.</p><p className="text-caption leading-relaxed text-foreground-muted">The summary condenses earlier messages, allowing you to see the full conversation history while the AI uses the condensed version for better performance.</p></div></div></div></DialogHeader>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== summaryString) {
    t6 = children ?? <ChatMarkdown content={summaryString} />;
    $[6] = children;
    $[7] = summaryString;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <DialogContent className="max-w-4xl">{t5}<DialogBody className="pt-6" onClick={handleImageClick}><div className="prose prose-sm prose-headings:font-semibold prose-headings:text-foreground prose-p:mb-3 prose-p:last:mb-0 prose-strong:text-foreground prose-strong:font-semibold prose-a:text-primary prose-a:no-underline hover:prose-a:underline dark:prose-invert max-w-none text-body leading-relaxed text-foreground">{t6}</div></DialogBody></DialogContent>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onOpenChange || $[12] !== open || $[13] !== t7) {
    t8 = <Dialog open={open} onOpenChange={onOpenChange}>{t7}</Dialog>;
    $[11] = onOpenChange;
    $[12] = open;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== previewImageUrl) {
    t9 = previewImageUrl && <Dialog open={!!previewImageUrl} onOpenChange={open_0 => {
      if (!open_0) {
        setPreviewImageUrl(null);
      }
    }}><DialogContent className="h-screen max-h-screen w-screen max-w-none" onInteractOutside={_temp}><DialogHeader className="flex-row justify-end"><DialogTitle className="sr-only">Fullscreen Image</DialogTitle><DialogClose asChild={true}><Button variant="ghost" icon={<FaXmark size={20} />} /></DialogClose></DialogHeader><DialogBody className="m-0 p-0"><div className="relative flex h-full w-full items-center justify-center overflow-hidden"><TransformWrapper>{() => <><Controls /><TransformComponent wrapperClass="!w-full !h-full" contentClass="!w-full !h-full items-center justify-center"><img src={previewImageUrl} alt="Full screen view" className="max-h-full max-w-full object-contain" /></TransformComponent></>}</TransformWrapper></div></DialogBody></DialogContent></Dialog>;
    $[15] = previewImageUrl;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp(e_0) {
  return e_0.preventDefault();
}